const PLATFORM_PREFIXES = [
  "/Partner",
  "/Super",
  "/Admin",
  "/Usher",
  "/event/dashboard",
  "/event/live",
  "/event/tickets",
  "/event/requests",
  "/event/orders",
  "/event/invitations",
  "/event/edit",
  "/events/create",
  "/Admins/",
  "/campaign/",
  "/Admin/",
];

const PUBLIC_AUTH_PATHS = ["/login", "/Login", "/register", "/forgot-password", "/reset-password", "/verify"];

export function isPlatformRoute(pathname = "") {
  if (!pathname) return false;
  if (PUBLIC_AUTH_PATHS.some((p) => pathname.toLowerCase().includes(p.toLowerCase()))) {
    return false;
  }
  return PLATFORM_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function isPlatformRole(role) {
  return ["Partner", "Admin", "Super", "Usher"].includes(role);
}
